<template>
  <transition name="fade">
      <section class="sidermenu-content" @click="closeMenu($event)">
        <div class="menu-wrapper">
          <ul>
            <li class="menu-item" v-for="(item,index) in menu " :key="index">
              <router-link :to="item.path">
                  <img class="menu-pic" :src="item.pic" :alt="item.text">
                  <p class="menu-text">{{item.text}}</p>
              </router-link>
            </li>
          </ul>
          <div class="menu-slogan">
            <img  class="menu-logo" src="../../assets/images/m_global_slogan_logo@3x.png" alt="果师兄">
            <h1>果师兄</h1>
            <h2>guoshixiong.com</h2>
            <img  class="menu-slogan" src="../../assets/images/m_global_slogan_word@3x.png" alt="让科技生活更简单">
          </div>
        </div>
      </section>
    </transition>
</template>

<script>
export default {
  name:"sidermenu",
  props:['showMenu'],
  data(){
    return{
      menu:[
        {
          pic:require('../../assets/images/m_sidebar_home@3x.png'),
          text:'首页',
          path:"/"
        },
        {
          pic:require('../../assets/images/m_sidebar_download@3x.png'),
          text:'下载',
          path:"/download"

        },
        {
          pic:require('../../assets/images/m_sidebar_faq@3x.png'),
          text:'常见问答',
          path:"/questionspage"

        },
        {
          pic:require('../../assets/images/m_sidebar_about@3x.png'),
          text:'关于我们',
          path:"/aboutus"

        },
      ]
    }
  },
  methods:{
    closeMenu(e){
      this.$emit('showmenu');
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/css/base.scss';
  .sidermenu-content{
    position: fixed;
    top:0;
    right: 0;
    left:0;
    bottom:0;
    background:rgba(0,0,0,0.2);
    z-index: 100000000;
    .menu-wrapper{
      width:px2vw(280px);
      height: 100vh;
      background:rgba(255,255,255,0.98);
      box-shadow:-6px 0px 6px 8px rgba(0,0,0,0.3);
      padding-top:pxtorem(40px);
      position: fixed;
      top:0;
      bottom:0;


    }
    .menu-item{
      height: pxtorem(64px);
      &:nth-child(odd){
        background:rgba(247,247,247,1);
      }
      a{
        display: flex;
        width:100%;
        height: pxtorem(64px);
        align-items: center;
        padding-left:pxtorem(27px);
        box-sizing: border-box;
        
      }
      .menu-pic{
        height:pxtorem(38px);
        flex-shrink: 0;
        margin-right:pxtorem(22px);
      }
      .menu-text{
        color:#1A1A1A;
        font-size: pxtorem(18px);
      }
    }
    .menu-slogan{
      margin-top:pxtorem(38px);
      .menu-logo{
          width:pxtorem(58px);
          box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);
          border-radius:10px;
          display: block;
          margin:0 auto;
      }
      .menu-slogan{
          width:pxtorem(144px);
          display: block;
          margin:pxtorem(15px) auto 0;
      }
      h1,h2{
        font-weight: normal;
        display: block;
        text-align: center;
      }
      h1{
        font-size:pxtorem(26px);
        color:rgba(38,38,38,1);
        margin-top:pxtorem(8px);
      }
      h2{
        font-size:pxtorem(10px);
        color:rgba(89,89,89,1);
        margin-top:pxtorem(4px);
      }
     
    }
  }
  .fade-enter-active, .fade-leave-active{
    transition: all 0.5s ease     
  }
  .fade-enter, .fade-leave-active{
  opacity: 0 
  }
  
</style>



// WEBPACK FOOTER //
// src/components/modules/SiderMenu.vue